import styled from "@emotion/styled";
import ButtonComponent from "@components/Button";
export const Title = styled.div`
  color: #3f4a59;
  font-family: Poppins Medium;
  text-align: center;
  font-size: 1em;
`;
export const Message = styled.div`
  margin-top: 2em;
  margin-bottom: 2em;
`;
export const Detail = styled.div`
  color: #3f4a59;
  font-family: Poppins Ligth;
  text-align: center;
  margin-top: 2em;
  font-size: 1em;
`;
export const Serial = styled.div`
  color: white;
  background-color: #90d1f4;
  font-family: Poppins Regular;
  padding: 0.5em 1em;
  margin-bottom: 1.5em;
  border-radius: 1em;
  font-size: 1.3em;
`;
export const Button = styled(ButtonComponent)`
  font-size: 1.2em;
  border-radius: 0.3em;
`;
